/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.14.0
 */

import { SkeletonParagraph } from '../../../../../components/common';
import { ESkeletonKind } from '../../../../../components/common/Skeleton/skeletonTypes';
import { SubscriberIdSkeletonStyled } from '../../styled/PageSubscriberIdStyled';

export const ManageNumberGeneralSkeleton = () => {
    return (
        <SubscriberIdSkeletonStyled>
            <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
            <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
            <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
            <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
            <SkeletonParagraph kind={ESkeletonKind.BUTTON_ROUND} style={{ width: 150 }}/>
        </SubscriberIdSkeletonStyled>
    );
};

export const ManageNumberSimCardSkeleton = () => {
    return (
        <SubscriberIdSkeletonStyled>
            <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
            <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL}/>
            <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
            <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL}/>
            <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
            <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL}/>
            <SkeletonParagraph kind={ESkeletonKind.BUTTON_ROUND} style={{ width: 150 }}/>
        </SubscriberIdSkeletonStyled>
    );
};

export const ManageNumberRedirectionSkeleton = () => {
    const style = { height: 100 };
    return (
        <SubscriberIdSkeletonStyled>
            <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
            <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL}/>
            <SkeletonParagraph kind={ESkeletonKind.BUTTON_ROUND} style={style} />
            <SkeletonParagraph kind={ESkeletonKind.BUTTON_ROUND} style={style} />
            <SkeletonParagraph kind={ESkeletonKind.BUTTON_ROUND} style={style} />
            <SkeletonParagraph kind={ESkeletonKind.BUTTON_ROUND} style={style} />
        </SubscriberIdSkeletonStyled>
    );
};

